import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class ProjectTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (ProjectTypeModel._instance == null) ProjectTypeModel._instance = new ProjectTypeModel(authManager);
        return ProjectTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'projects/project-types', 'projects/project-types/codelist');

        this.entityName = 'projects.ProjectType';
        this.privileges = {
            create: [["adminProjects"]],
            read: [["adminProjects"],["manageProjects"],["editProjects"],["readProjects"]],
            update: [["adminProjects"]],
            delete: [["adminProjects"]],
        };

        this.label = 'Project Type';
        this.setLabel = 'Project Types';

        this.browser = {
            name: 'default-projects-projecttype-browser',
            moduleName: 'default-projects-projecttype-browser',
            moduleTitle: 'Project Types',
            moduleStateSlotName: 'default-projects-projecttype-browser',
        };

        this.editor = {
            name: 'default-projects-projecttype-editor',
            moduleName: 'default-projects-projecttype-editor',
            moduleTitle: 'Project Type',
            moduleStateSlotName: 'default-projects-projecttype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
